export const Status = ({ status, show = true, children }) => {
    return show ? (
        <div>
            {status === "success" && children}
            {status === "loading" && <div className="status-spinner"> </div>}
            {status === "error" && <p> There was an error processing your request. Please try again.</p>}
        </div>
    ) : (
        children
    )
}
